import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

const OLD_ROUTES_CONSTANTS = [
  'disbursementAccountSelection',
  'account/disbursementAccountSelection',
  'account/dispersionEfecty',
  'account/customDispersionChannel',
];

const ROUTES_CONSTANT = {
  HOME: '/home',
  DISPERSION_METHOD: 'dispersion-method',
};

@Injectable({
  providedIn: 'root',
})
export class DispersionMethodGuard implements CanActivate {
  private readonly oldRoutes = [...OLD_ROUTES_CONSTANTS];

  constructor(private readonly router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const url = route.url.map((segment) => segment.path).join('/');

    if (this.oldRoutes.includes(url)) {
      return this.router.createUrlTree([ROUTES_CONSTANT.DISPERSION_METHOD]);
    }

    return true;
  }
}
